import React from 'react';
import { useIsMobile } from 'utils/hooks';
import { Dialog, Div, H1 } from 'components/Ui';
import {
  BrowserChrome,
  BrowserSafari,
  BrowserEdge,
  BrowserFirefox,
  GreenAlert,
} from 'images/index';
import Grid from '@material-ui/core/Grid';
import styles from './styles.scss';

const UnsupportedBrowserDialog = (props) => {
  const { logout, notLoggedIn } = props;
  const isMobile = useIsMobile();

  const notLogIn = () => null;

  const title = 'Unsupported browser';
  const message =
    "It looks like you may be using a web browser that we don't support. \n For the best experience, please make sure you're using the most recent version of your browser, or try using one of these supported browsers below.";
  const chromeURL = 'https://www.google.com/chrome';
  const safariURL = 'https://support.apple.com/safari';
  const edgeURL = 'https://www.microsoft.com/edge';
  const firefoxURL = 'https://www.mozilla.org/en-US/firefox/';

  const handleClick = (url) => {
    window.open(url);
    logout();
  };
  return (
    <Dialog
      open
      size="medium"
      isAutoClose={false}
      isCloseIcon={!notLoggedIn}
      onClose={!notLoggedIn ? logout : notLogIn}
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
        >
          <img className={styles.dialogAlert} src={GreenAlert} alt="alert" />
          <H1 id="dialog-title">{title}</H1>
          <Div className={styles.messageContainer} id="dialog-message">
            {message}
          </Div>
          <Grid container spacing={1} justify="center">
            <Grid className={styles.imageContainer} item sm={3}>
              <a
                onClick={() => handleClick(chromeURL)}
                href={chromeURL}
                target="_blank"
              >
                <img
                  border="0"
                  alt={'Download the Chrome Browser'}
                  src={BrowserChrome}
                />
              </a>
            </Grid>
            <Grid className={styles.imageContainer} item sm={3}>
              <a
                onClick={() => handleClick(firefoxURL)}
                href={firefoxURL}
                target="_blank"
              >
                <img
                  border="0"
                  alt={'Download the Firefox Browser'}
                  src={BrowserFirefox}
                />
              </a>
            </Grid>
            <Grid className={styles.imageContainer} item sm={3}>
              <a
                onClick={() => handleClick(safariURL)}
                href={safariURL}
                target="_blank"
              >
                <img
                  border="0"
                  alt={'Download the Safari Browser'}
                  src={BrowserSafari}
                />
              </a>
            </Grid>
            <Grid className={styles.imageContainer} item sm={3}>
              <a
                onClick={() => handleClick(edgeURL)}
                href={edgeURL}
                target="_blank"
              >
                <img
                  border="0"
                  alt={'Download the Edge Browser'}
                  src={BrowserEdge}
                />
              </a>
            </Grid>
          </Grid>
          <Grid container spacing={1} justify="center">
            <Grid className={styles.imageTextContainer} item sm={3}>
              <span>Chrome</span>
            </Grid>
            <Grid className={styles.imageTextContainer} item sm={3}>
              <span>Firefox</span>
            </Grid>
            <Grid className={styles.imageTextContainer} item sm={3}>
              <span>Safari</span>
            </Grid>
            <Grid className={styles.imageTextContainer} item sm={3}>
              <span>Edge</span>
            </Grid>
          </Grid>
        </div>
      </div>
    </Dialog>
  );
};

export default UnsupportedBrowserDialog;
